export const itemVariant = {
  short: 'short',
  shortWide: 'short-wide',
  tall: 'tall',
  tallWide: 'tall-wide',
} as const

export type ItemVariants = typeof itemVariant[keyof typeof itemVariant]
